import { useCallback, useState } from "react"

interface UseDialogStateProps {
  onSuccess?: () => void
}

interface UseDialogStateReturn {
  isDialogOpen: boolean
  openDialog: () => void
  closeDialog: () => void
  handleSuccess: () => void
}

/**
 * General hook for managing dialog open/close state with optional success callback
 * Can be used across all dialogs throughout the application
 */
export const useDialogState = ({ onSuccess }: UseDialogStateProps = {}): UseDialogStateReturn => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const openDialog = useCallback(() => {
    setIsDialogOpen(true)
  }, [])

  const closeDialog = useCallback(() => {
    setIsDialogOpen(false)
  }, [])

  const handleSuccess = () => {
    onSuccess?.()
    setIsDialogOpen(false)
  }

  return {
    isDialogOpen,
    openDialog,
    closeDialog,
    handleSuccess,
  }
}
